import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateNavbarHeading } from '../../../../constants/layout/store/filterSlice';
import SuperAdminTable from './Component/SuperAdminTable';
import { GetServiceCaller } from '../../../../services/serviceCaller';
import { API_URL } from '../../../../constants';

const EmployeeAdminList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Admin Tickets"))
    }, [])
    const [searchTerm, setSearchTerm] = useState("");
    const [employeeAdminListData, setEmployeeAdminListData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiStatus, SetApiStatus] = useState(undefined);

    const columns = {
        TicketNumber: { text: "Ticket#", width:"90px",align: "center", visible: true },
        EmployeeName: { text: "Employee", align: "start", visible: true },
        RequisitionType: { text: "Category", align: "left", visible: true },
        SubCategory: { text: "Sub Category", align: "left", visible: true },
        FileName: { text: "Attachment", align: "start", type:'Link',  visible: true },
        TXNDate: { text: "Applied Date", align: "center", visible: true },
        Details: { text: "Details", align: "left", visible: true },
        ApplicationStatus: { text: "Status", align: "center", visible: true },
        ClosureDate: { text: "Closure Date", align: "center", visible: false },
        ActionByName: { text: "Action By", align: "left", visible: false },
        ActionRemarks: { text: "Action Remarks", align: "left", visible: false },

    };

    useEffect(() => {
        fetchGetEmployeeAdminList();
    }, []); // Empty dependency array ensures it runs once on mount

    const fetchGetEmployeeAdminList = async () => {
        SetApiStatus(undefined)
        try {
            const queryParams = new URLSearchParams({ admin: '0' }).toString();
            const response = await GetServiceCaller(`${API_URL}requisition/admin?${queryParams}`);
            SetApiStatus(response?.status);
            if (response?.status === 200) {
                const cleanedData = response?.data?.data || [];
                setEmployeeAdminListData(cleanedData);
            } else {
                console.error(
                    "Failed to fetch Employee Admin List. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Employee Admin List:", error);
        } finally {
            setLoading(false); // Always stop loading, even if there's an error
        }
    };

    const handleEdit = (id) => {
        navigate(`/admin/tickets/edit/${id.ID}`)

    }
    const handleAddNewVendor = () => {
        navigate(`/admin/tickets/add`)

    }
    return (
        <>
            <div className="container-fluid" id="skill_section">
                <div className="container-fluid" id="skill-table-area">
                    <div className="row">
                        <SuperAdminTable
                            data={employeeAdminListData}
                            columns={columns}
                            itemsPerPage={10}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            isSorting={true}
                            isApiStatus={apiStatus}
                            isRequiredStatus={true}
                            showIcon1={true}
                            showIcon2={false}
                            isActionRequired={true}
                            isAddNewBtnRequired={true}
                            showIcon3={false}
                            showIcon4={false}
                            showIcon5={false}
                            handleIcon1={handleEdit}
                            handleAddNew={handleAddNewVendor}
                            add
                            more
                            function
                            icons={{
                                Icon1: <i className="bi bi-pencil-square icons"></i>,
                                Icon1Text: " Edit",
                                Icon1Flag:"canEdit",
                                Icon2: <i className="bi bi-trash-fill icons"></i>,
                                Icon3: <i className="bi bi-eye-fill icons"></i>,
                                Icon4: <i className="bi bi-plus-square icons"></i>,
                                Icon4Text: " Add Sub-Contractor",
                            }}
                        />
                    </div>
                </div>

            </div>
        </>
    )
}

export default EmployeeAdminList